import store from '@/store/index'

/**
 * 
 * @param {*} theme 主题：
 * light(日间模式) dark(夜间模式) mobile(移动端模式)
 */
export function getOverrides(theme = 'dark') { //Widget对象的默认属性进行覆盖
  let upDown=store.state.upDown
  const themes = {
    "light": { //日间模式
      up: "#38AF75",
      down: "#E75A5B",
      bg: "#ffffff",
      grid: "#f7f8fa",
      cross: "#23283D",
      border: "#9194a4",
      text: "#9194a4",
      areatop: "rgba(71, 78, 112, 0.1)",
      areadown: "rgba(71, 78, 112, 0.02)",
      line: "#737375"
    },
    "dark": { //夜间模式
      up: "#38AF75", //38AF75
      down: "#E75A5B",
      bg: "#0E1D2C",
      grid: "rgb(27, 42, 58)", //122130
      cross: "#37a6ef",
      border: "#4d596e",
      text: "#6b7e93",
      areatop: "rgba(122, 152, 247, .1)",
      areadown: "rgba(122, 152, 247, .02)",
      line: "#737375"
    },
    "mobile": { //移动端模式
      up: "#03C087",
      down: "#E76D42",
      bg: "#ffffff",
      grid: "#f7f8fa",
      cross: "#23283D",
      border: "#C5CFD5",
      text: "#8C9FAD",
      areatop: "rgba(71, 78, 112, 0.1)",
      areadown: "rgba(71, 78, 112, 0.02)",
      showLegend: !0
    }
  }
  const t = themes[theme];
  return {
    volumePaneSize: "medium",  //支持的值: large, medium, small, tiny
    "paneProperties.legendProperties.showLegend": 1,
    // "mainSeriesProperties.style": 3, 
    //  Bars = 0            #美国线
    //  Candles = 1         #K线图
    //  Line = 2            #线形图
    //  Area = 3            #面积图
    //  Heiken Ashi = 8     #平均K线图
    //  Hollow Candles = 9  #空心K线图
    //  Renko = 4           #转形图
    //  Kagi = 5            #卡吉图
    //  Point&Figure = 6    #点数图
    //  Line Break = 7      #新价图
  "paneProperties.background": t.bg,
  "paneProperties.vertGridProperties.color": t.grid, // 栅格竖颜色
  "paneProperties.horzGridProperties.color": t.grid, // 栅格横颜色
  "paneProperties.crossHairProperties.color": t.border, // 虚线颜色 border == grid2
  "scalesProperties.backgroundColor": t.bg,
    // 坐标轴刻度颜色
  "scalesProperties.lineColor": t.border,
  "scalesProperties.textColor": t.text,

  "mainSeriesProperties.candleStyle.upColor": upDown===1?t.up:t.down,
  "mainSeriesProperties.candleStyle.borderColor": upDown===1?t.up:t.down,
  "mainSeriesProperties.candleStyle.borderUpColor": upDown===1?t.up:t.down,
  "mainSeriesProperties.candleStyle.wickColor": upDown===1?t.up:t.down,
  "mainSeriesProperties.candleStyle.wickUpColor": upDown===1?t.up:t.down,
  "mainSeriesProperties.hollowCandleStyle.upColor": upDown===1?t.up:t.down,

  "mainSeriesProperties.hollowCandleStyle.borderColor": t.border,
  "mainSeriesProperties.hollowCandleStyle.borderUpColor": t.border,
  "mainSeriesProperties.hollowCandleStyle.wickColor": t.line,

  "mainSeriesProperties.hollowCandleStyle.wickUpColor": upDown===1?t.up:t.down,
  "mainSeriesProperties.haStyle.upColor": upDown===1?t.up:t.down,

  "mainSeriesProperties.haStyle.borderColor": t.border,
  "mainSeriesProperties.haStyle.borderUpColor": t.border,

  "mainSeriesProperties.haStyle.wickUpColor": upDown===1?t.up:t.down,
  "mainSeriesProperties.barStyle.upColor": upDown===1?t.up:t.down,
  "mainSeriesProperties.candleStyle.downColor": upDown===1?t.down:t.up,
  "mainSeriesProperties.candleStyle.borderDownColor": upDown===1?t.down:t.up,
  "mainSeriesProperties.candleStyle.wickDownColor": upDown===1?t.down:t.up,
  "mainSeriesProperties.hollowCandleStyle.downColor": upDown===1?t.down:t.up,
  "mainSeriesProperties.hollowCandleStyle.borderDownColor": upDown===1?t.down:t.up,
  "mainSeriesProperties.hollowCandleStyle.wickDownColor": upDown===1?t.down:t.up,
  "mainSeriesProperties.haStyle.downColor": upDown===1?t.down:t.up,
  "mainSeriesProperties.haStyle.borderDownColor": upDown===1?t.down:t.up,
  "mainSeriesProperties.haStyle.wickDownColor": upDown===1?t.down:t.up,
  "mainSeriesProperties.barStyle.downColor": upDown===1?t.down:t.up,

  "paneProperties.legendProperties.showStudyArguments": !0,
  "paneProperties.legendProperties.showStudyTitles": !0,
  "paneProperties.legendProperties.showStudyValues": !0,
  "paneProperties.legendProperties.showSeriesTitle": !0,
  "paneProperties.legendProperties.showSeriesOHLC": !0,
  "mainSeriesProperties.candleStyle.drawWick": !0,
  "mainSeriesProperties.candleStyle.drawBorder": !0,
  "mainSeriesProperties.candleStyle.barColorsOnPrevClose": !1,
  "mainSeriesProperties.hollowCandleStyle.drawWick": !0,
  "mainSeriesProperties.hollowCandleStyle.drawBorder": !0,
  "mainSeriesProperties.haStyle.drawWick": !0,
  "mainSeriesProperties.haStyle.drawBorder": !0,
  "mainSeriesProperties.haStyle.wickColor": t.border,
  "mainSeriesProperties.haStyle.barColorsOnPrevClose": !1,
  "mainSeriesProperties.barStyle.barColorsOnPrevClose": !1,
  "mainSeriesProperties.barStyle.dontDrawOpen": !1,
  "mainSeriesProperties.lineStyle.color": t.border,
  "mainSeriesProperties.lineStyle.linewidth": 1,
  "mainSeriesProperties.lineStyle.priceSource": "close",
  // 面积图样式
  "mainSeriesProperties.areaStyle.color1": "rgba(51, 117, 224,0.5)",
  "mainSeriesProperties.areaStyle.color2": "rgba(51, 117, 224,0.01)",
  "mainSeriesProperties.areaStyle.linecolor":"rgba(51, 117, 224,0.5)",
  "mainSeriesProperties.areaStyle.linewidth": 1,
  "mainSeriesProperties.areaStyle.priceSource": "close",

  // "mainSeriesProperties.areaStyle.color1": "#d1d4dc",
  // "mainSeriesProperties.areaStyle.color2": "#f6f7f8",
  // "mainSeriesProperties.areaStyle.linecolor": "#d1d4dc",
  // "mainSeriesProperties.areaStyle.linestyle": 0,
  // "mainSeriesProperties.areaStyle.linewidth": 2,


  }
}

/**
 * 
 * @param {*} theme 
 * light(日间模式) dark(夜间模式) mobile(移动端模式)
 */
export function getStudiesOverrides(theme = 'dark') { //自定义默认指标的样式及输入值
  let upDown=store.state.upDown

  const themes = {
    "light": {
      c0: "#38AF75",
      c1: "#E75A5B",
      t: 70,
      v: !1
    },
    "dark": {
      c0: "#38AF75",
      c1: "#E75A5B",
      t: 70,
      v: !1
    },
    // up: "#38AF75"
      // down: "#E75A5B",
    "mobile": {
      c0: "#fd8b8b",
      c1: "#3cb595",
      t: 70,
      v: !1
    }
  };
  const t = themes[theme];
  return {
    "volume.volume.color.0": upDown===0? t.c0:t.c1,
    "volume.volume.color.1":  upDown===0?t.c1:t.c0,
    "volume.volume.transparency": t.t,
    "volume.options.showStudyArguments": t.v,
  }
}
